<template>
  <header
    class="header"
    :style="{ pointerEvents: routeName === 'index' ? 'none' : 'auto' }"
    js-header="def"
  >
    <transition @enter="enter" @leave="leave" mode="out-in">
      <div class="ui-container" v-if="routeName === 'index' || routeName === 'errorPage'" key=1>
        <Logo @click="menuIsOpen = false" />
      </div>
      <div class="ui-container" v-else key=2>
        <Logo @click="menuIsOpen = false" />

        <div>
          <BaseButton
            class="header__button u-hidden--from-menuL"
            :data="dataButton"
          />

          <div
            :class="['burger-menu', 'u-hidden--from-menuL', menuIsOpen ? 'burger-menu--close' : '']"
            @click="toggleMenu"
          >
          </div>
        </div>

        <Navigator
          :class="[menuIsOpen ? 'navigator--open' : '']"
          :toggleMenu="toggleMenu"
        />
      </div>
    </transition>
  </header>
</template>

<script>
import { mapGetters } from 'vuex';
import anime from 'animejs';

import Logo from '@/components/Logo.vue';
import BaseButton from '@/components/BaseButton.vue';
import Navigator from '@/components/ui/Navigator.vue';

import loop from '@/scripts/loop';


export default {
  name: 'headerComp',

  components: {
    Logo,
    Navigator,
    BaseButton,
  },

  props: {
    menuOpen: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      currentScroll: window.pageYOffset,
      prevScroll: 0,
      direction: '',
      limit: 0,

      menuIsOpen: false,
    };
  },

  computed: {
    ...mapGetters({ routeName: 'getRouteName', getCity: 'getCity' }),
    dataButton() {
      if (this.getCity === 'amsterdam') {
        return {
          url: 'https://www.universe.com/events/digital-thinkers-conf-amsterdam-tickets-amsterdam-PJS7VG',
          content: 'Get Tickets',
        };
      }
      if (this.getCity === 'san-francisco') {
        return {
          url: 'https://www.universe.com/events/digital-thinkers-conf-san-francisco-by-awwwards-tickets-san-francisco-KM9T0Q',
          content: 'Get Tickets',
        };
      }
      return {
        url: 'https://www.universe.com/events/designing-new-experiences-to-sell-more-tickets-new-york-39DKQN',
        content: 'Get Tickets',
      };
    },
  },

  created() {
    this.setLimit();
    this.$eventHub.$on('windowResize', this.setLimit);
  },

  mounted() {
    loop.add(this.onTick, 'setMenu');
  },

  methods: {
    onTick() {
      this.getDirection();
      this.setMenu();
    },

    toggleMenu() {
      this.menuIsOpen = !this.menuIsOpen;
      this.$parent.setStateMenu(this.menuIsOpen);
    },

    getDirection() {
      this.currentScroll = window.lerpedScrollY;

      if (this.currentScroll > this.prevScroll && this.direction !== 'down') {
        this.direction = 'down';
      } else if (this.currentScroll < this.prevScroll && this.direction !== 'up') {
        this.direction = 'up';
      }

      this.prevScroll = window.lerpedScrollY;
    },

    setLimit() {
      this.limit = this.routeName === 'home' ? window.innerHeight : Math.round(window.innerHeight / 1.5);
    },

    setMenu() {
      if (window.lerpedScrollY > this.limit && this.$el.getAttribute('js-header') !== 'hidden' && this.direction === 'down') {
        this.$el.setAttribute('js-header', 'hidden');
      } else if (window.lerpedScrollY > this.limit && this.$el.getAttribute('js-header') !== 'show' && this.direction === 'up') {
        this.$el.setAttribute('js-header', 'show');
      } else if (window.lerpedScrollY < this.limit && this.$el.getAttribute('js-header') !== 'def' && this.direction === 'up') {
        this.$el.setAttribute('js-header', 'def');
      }
    },

    enter(el, done) {
      el.style.opacity = 0;
      anime({
        targets: el,
        duration: 1000,
        opacity: [0, 1],
        translateY: [20, 0],
        delay: 1200,
        complete: () => {
          el.removeAttribute('style');
          done();
        },
      });
    },

    leave(el, done) {
      anime({
        targets: el,
        duration: 1200,
        opacity: [1, 0],
        translateY: [0, 20],
        complete: done,
      });
    },
  },

  beforeDestroy() {
    this.$eventHub.$off('resize', this.setLimit);
  },
};
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  padding: 0 20px;
  background-color: rgba(242, 242, 242, 1);

  @at-root [data-page="index"] & {
    background-color: transparent;
  }

  @at-root [data-page="errorPage"] & {
    background-color: transparent;
  }

  backface-visibility: hidden;
  transform-style: preserve-3d;
  transform: translateY(0);
  will-change: transform, background-color;

  @include mq(mobile) {
    padding: 0 30px;
  }

  @include mq(menuL) {
    background-color: rgba(242, 242, 242, 0);
    transition: all 0.5s ease-out;
    transform: translateY(0);

    &[js-header="show"] {
      transform: translateY(0);
      background-color: rgba(242, 242, 242, 1);

      @at-root [js-headervisible] & {
        background-color: rgba(242, 242, 242, 1);

        @include mq(ipadP) {
          background-color: rgba(242, 242, 242, 0);
        }
      }
    }

    &[js-header="hidden"] {
      transform: translateY(-100%);
      background-color: rgba(242, 242, 242, 1);

      @at-root [js-headervisible] & {
        transform: translateY(0);
        background-color: rgba(242, 242, 242, 1);

        @include mq(ipadP) {
          background-color: rgba(242, 242, 242, 0);
        }
      }
    }
  }

  @include mq(ipadP) {
    padding: 0 40px;
  }

  @include mq(ipadL) {
    padding: 0 80px;
  }

  z-index: z-index(header);

  .ui-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;

    padding: 20px 0;

    @include mq(ipadP) {
      position: relative;
      padding: 40px 0;
    }

    @include mq(ipadL) {
      padding: 30px 0 40px;
    }
  }

  &__button {
    margin-right: 20px;

    @include mq(mobile) {
      margin-right: 30px;
    }

    @include mq(ipadP) {
      margin-right: 40px;
    }
  }

  .burger-menu {
    display: inline-block;
    position: relative;
    width: 18px;
    height: 13px;

    cursor: pointer;

    &::before,
    &::after {
      content: "";

      position: absolute;
      left: 0;
      width: 100%;
      height: 2px;

      background-color: $color-text;
      transition: all 0.4s $global-ease;
      transform-origin: 50% 50%;
    }

    &::before {
      top: 0;
    }

    &::after {
      top: 100%;
    }

    &.burger-menu--close {
      &::before,
      &::after {
        top: 50%;
      }

      &::before {
        transform: rotate(45deg);
      }

      &::after {
        transform: rotate(-45deg);
      }
    }
  }
}

.sold-out {
  display: block;
  pointer-events: auto;

  @include mq($until: mobileL) {
    color: $color-light;
    background: #a0726f;
    position: absolute;
    top: 0;
    left: -30px;
    width: calc(100% + 60px);
    height: 30px;
    font-size: 14px;
    line-height: 30px;
    text-align: center;
    z-index: 10;
  }
  color: $color-white;

  &-ribbon {
    position: relative;
    display: block;
    pointer-events: auto;

    .sold-out__svg {
      position: absolute;
      top: 0;
      right: 0;
      width: 100px;

      animation: rotation 8s linear infinite;

      path {
        fill: $color-white;

        @include mq(ipadL) {
          fill: $color-yellow;
        }
      }
    }
  }
}

// .ui-container {
//   @at-root [data-page="index"] & {
//     @include mq($until: mobileL) {
//       padding-top: 60px;
//     }
//   }
// }

@keyframes rotation {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(1turn);
  }
}
</style>
